import { ReactNode, SyntheticEvent } from 'react';
import { ResultContent, WorkshopIcon, Wrapper } from './ui';

type SearchResultItem = {
  handleClick(e: SyntheticEvent): void;
  title: ReactNode;
  type?: string;
  isLast: boolean;
}

export const SearchResultItem = ({ handleClick, title, type, isLast }: SearchResultItem) => {
  const isWorkshop = type === 'workshops';
  
  return (
    <Wrapper handleClick={handleClick} isLast={isLast} isHighlighted={isWorkshop}>
      <ResultContent>
        {isWorkshop && <WorkshopIcon />}
        <span>{title}</span>
      </ResultContent>
    </Wrapper>
  )
}
